/*
  曹秀芳
  2019.11.06
  制作PartsFaultAlarm页面
  赵祥悦 2020.09.01 增加伺服轴筛选项,2020.09.07 初始化默认显示修改
*/ 
<template>
  <div class="PartsFaultAlarm mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/PFA001"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navSeven2')}}</h1>
                <div class="machineSeach">
                  <label style="margin-right:10px;font-size:12px;">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                  <equipment @change="getchange" class="machinevue" :machine="Number(machineId)" :show="true"></equipment>
                </div>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
              <!-- 我的 -->
                <div class="tableWrap">
                    <div class="titleRow" v-loading="seachLoading">
                        <!-- 部件 -->
                          <div style="margin-right:20px;">
                            <label class="code-margin">{{$t('PartsFaultAlarm.part')}}：</label>
                            <el-select v-model="partName" style="width:130px;" clearable :placeholder="$t('PartsFaultAlarm.all')" @change="changeLine">
                              <el-option
                                  v-for="item in partNameArr"
                                  :key="item.label"
                                  :label="item.label"
                                  :value="item.value">
                              </el-option>
                            </el-select>
                          </div>
                        <!-- 日历 -->
                        <span style="color:red;font-size:20px;margin:0px 10px 0 0;">*</span>
                        <el-date-picker
                            v-model="selectTime"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            :start-placeholder="$t('PartsFaultAlarm.StartTime')"
                            :end-placeholder="$t('PartsFaultAlarm.EndTime')"
                            @change="changeTimes">
                        </el-date-picker>
                        <!-- 图标 -->
                          <div class="showself">
                            <span class="ShowWord">{{$t('PartsFaultAlarm.show')}} :</span>
                            <el-checkbox-group v-model="checkList" @change="selectIcons()">
                              <el-checkbox :label="$t('PartsFaultAlarm.Faults')"></el-checkbox>
                              <svg style="width:18px;height:18px;vertical-align:middle;margin:0 0 8px 4px;" t="1574665043593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859" width="200" height="200"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#d81e06" opacity=".1" p-id="5860"></path><path d="M532.741689 284.603733L781.653333 717.198222a22.755556 22.755556 0 0 1-19.717689 34.110578H262.052978a22.755556 22.755556 0 0 1-19.683556-34.178844L493.340444 284.535467a22.755556 22.755556 0 0 1 39.412623 0.068266z m-26.0096 110.546489a17.066667 17.066667 0 0 0-17.066667 17.066667v188.461511a17.066667 17.066667 0 0 0 17.066667 17.066667h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066667V412.216889a17.066667 17.066667 0 0 0-17.066667-17.066667h-10.376533z m0 244.849778a17.066667 17.066667 0 0 0-17.066667 17.066667v10.387911a17.066667 17.066667 0 0 0 17.066667 17.066666h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066666v-10.376534a17.066667 17.066667 0 0 0-17.066667-17.066666h-10.376533z" fill="#d81e06" p-id="5861"></path></svg>
                              <!-- <alertIcon title="" :class="{'navIcon':true,'iconse':true,'iconcolor':faultsicon}"/> -->
                              <el-checkbox :label="$t('PartsFaultAlarm.Alarms')"></el-checkbox>
                              <svg style="width:18px;height:18px;vertical-align:middle;margin-bottom:8px;" t="1574664885183" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4902" width="200" height="200"><path d="M581.42 802.43a69.17 69.17 0 0 1-137.21 0h-96.35c4.62 87 76.84 156.34 164.95 156.34s160.34-69.35 165-156.34z" fill="#d81e06" p-id="4903" data-spm-anchor-id="a313x.7781069.0.i13" class="selected"></path><path d="M851.94 704.45l-81.74-83.4a29.68 29.68 0 0 1-8.47-20.76V428.54c0-66.41-26-129-73.24-176.22a251.8 251.8 0 0 0-55.63-42.06 121.41 121.41 0 1 0-238-1.76 251.5 251.5 0 0 0-58.82 43.82c-47.23 47.23-73.24 109.81-73.24 176.22v171.55a29.68 29.68 0 0 1-8.46 20.75l-81.68 83.4-0.2 0.21a71.76 71.76 0 0 0 51.6 121.65h576.31a71.76 71.76 0 0 0 51.57-121.65zM514.05 159.83a25.44 25.44 0 0 1 25 20.7 249.56 249.56 0 0 0-26.73-1.44q-11.65 0-23.13 1.08a25.45 25.45 0 0 1 24.86-20.34zM281.73 730.1l52.64-51.75c13.08-12.42 24.46-25.88 24.46-43.83v-206a153.45 153.45 0 0 1 306.9 0v206c0 17.76 12.23 33.1 24 44.56l52.94 51z" fill="#e98f36" p-id="4904" data-spm-anchor-id="a313x.7781069.0.i12" class=""></path></svg>
                              <!-- <i :class="{'el-icon-bell':true,'iconse':true,'iconcolor':alarmsicon}" style="font-weight: 800;"></i> -->
                              <el-checkbox :label="$t('PartsFaultAlarm.Resets')" disabled></el-checkbox><replyIcon title="" :class="{'navIcon':true,'iconse':true,'iconcolor':resetsicon}" style="font-size:20px"/>
                            </el-checkbox-group>
                          </div>
                    </div>
                    <div class="datePick">
                        <el-row>
                          <!-- 代码/描述输入查询 -->
                          <label class="code-margin">{{$t('PartsFaultAlarm.tableTitle3')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('PartsFaultAlarm.enterText')"
                            v-model="input"
                            clearable>
                          </el-input>
                          <!-- 增加伺服轴筛选项 -->
                          <label class="code-margin">{{$t('PartsFaultAlarm.tableTitle5')}}：</label>
                          <el-input
                            class="code-select-width"
                            :placeholder="$t('PartsFaultAlarm.enterText')"
                            v-model="servoAxis"
                            clearable>
                          </el-input>
                          <!-- 代码/描述输入查询 -->
                          <label class="code-margin except">{{$t('PartsFaultAlarm.tableTitle6')}}：</label>
                          <el-input
                            class="code-select-width except"
                            :placeholder="$t('PartsFaultAlarm.enterText')"
                            v-model="exceptinput"
                            clearable
                            @blur="blurexcept"
                            @clear="clearexcept">
                          </el-input>
                          <!-- 三个按钮 -->
                          <div class="btns">
                              <el-button size="small" @click="btn_clean()">{{$t('EventRecord.Clean')}}</el-button>
                              <el-button type="primary" size="small" icon="el-icon-search" @click="getEventRecordList()">{{$t('PartsFaultAlarm.search')}}</el-button>
                              <el-button size="small" v-show="this.$store.state.authority.PageDownload.show" @click="btn_export" style="vertical-align:bottom; padding:7px 15px;"><downloadIcon style="font-size:14px;" title=""/> {{$t('EventRecord.Export')}}</el-button>
                          </div>
                        </el-row>
                    </div>
                    <!-- 两个柱形图 -->
                    <!-- <div class="chartWrap">
                      <div id="myChart"></div>
                      <div id="myChart2"></div>
                    </div> -->
                    <!-- 表格 -->
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      style="width: 100%"
                      :stripe='true'
                      :border='true'
                      :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                      @sort-change="highSeaOrder">
                    <!-- 日期时间 -->
                      <el-table-column
                        fixed
                        sortable="custom"
                        prop="startTime"
                        :label="$t('PartsFaultAlarm.tableTitle1')"
                        width="220">
                        <template slot-scope="scope">
                          <svg v-if="scope.row.iconColor === '1绿'" style="width:18px;height:18px;vertical-align:middle;" t="1574665043593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859" width="200" height="200" data-spm-anchor-id="a313x.7781069.0.i22"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1afa29" opacity=".1" p-id="5860" data-spm-anchor-id="a313x.7781069.0.i18" class="selected"></path><path d="M532.741689 284.603733L781.653333 717.198222a22.755556 22.755556 0 0 1-19.717689 34.110578H262.052978a22.755556 22.755556 0 0 1-19.683556-34.178844L493.340444 284.535467a22.755556 22.755556 0 0 1 39.412623 0.068266z m-26.0096 110.546489a17.066667 17.066667 0 0 0-17.066667 17.066667v188.461511a17.066667 17.066667 0 0 0 17.066667 17.066667h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066667V412.216889a17.066667 17.066667 0 0 0-17.066667-17.066667h-10.376533z m0 244.849778a17.066667 17.066667 0 0 0-17.066667 17.066667v10.387911a17.066667 17.066667 0 0 0 17.066667 17.066666h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066666v-10.376534a17.066667 17.066667 0 0 0-17.066667-17.066666h-10.376533z" fill="#1afa29" p-id="5861" data-spm-anchor-id="a313x.7781069.0.i19" class="selected"></path></svg>
                          <svg v-else-if="scope.row.iconColor=== '1红'" style="width:18px;height:18px;vertical-align:middle;" t="1574665043593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859" width="200" height="200"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#d81e06" opacity=".1" p-id="5860"></path><path d="M532.741689 284.603733L781.653333 717.198222a22.755556 22.755556 0 0 1-19.717689 34.110578H262.052978a22.755556 22.755556 0 0 1-19.683556-34.178844L493.340444 284.535467a22.755556 22.755556 0 0 1 39.412623 0.068266z m-26.0096 110.546489a17.066667 17.066667 0 0 0-17.066667 17.066667v188.461511a17.066667 17.066667 0 0 0 17.066667 17.066667h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066667V412.216889a17.066667 17.066667 0 0 0-17.066667-17.066667h-10.376533z m0 244.849778a17.066667 17.066667 0 0 0-17.066667 17.066667v10.387911a17.066667 17.066667 0 0 0 17.066667 17.066666h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066666v-10.376534a17.066667 17.066667 0 0 0-17.066667-17.066666h-10.376533z" fill="#d81e06" p-id="5861"></path></svg>
                          <svg v-else-if="scope.row.iconColor === '2红'" style="width:18px;height:18px;vertical-align:middle;" t="1574664885183" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4902" width="200" height="200"><path d="M581.42 802.43a69.17 69.17 0 0 1-137.21 0h-96.35c4.62 87 76.84 156.34 164.95 156.34s160.34-69.35 165-156.34z" fill="#d81e06" p-id="4903" data-spm-anchor-id="a313x.7781069.0.i13" class="selected"></path><path d="M851.94 704.45l-81.74-83.4a29.68 29.68 0 0 1-8.47-20.76V428.54c0-66.41-26-129-73.24-176.22a251.8 251.8 0 0 0-55.63-42.06 121.41 121.41 0 1 0-238-1.76 251.5 251.5 0 0 0-58.82 43.82c-47.23 47.23-73.24 109.81-73.24 176.22v171.55a29.68 29.68 0 0 1-8.46 20.75l-81.68 83.4-0.2 0.21a71.76 71.76 0 0 0 51.6 121.65h576.31a71.76 71.76 0 0 0 51.57-121.65zM514.05 159.83a25.44 25.44 0 0 1 25 20.7 249.56 249.56 0 0 0-26.73-1.44q-11.65 0-23.13 1.08a25.45 25.45 0 0 1 24.86-20.34zM281.73 730.1l52.64-51.75c13.08-12.42 24.46-25.88 24.46-43.83v-206a153.45 153.45 0 0 1 306.9 0v206c0 17.76 12.23 33.1 24 44.56l52.94 51z" fill="#e98f36" p-id="4904" data-spm-anchor-id="a313x.7781069.0.i12" class=""></path></svg>
                          <svg v-else-if="scope.row.iconColor === '2绿'" style="width:18px;height:18px;vertical-align:middle;" t="1574665380489" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7041" width="200" height="200"><path d="M581.42 802.43a69.17 69.17 0 0 1-137.21 0h-96.35c4.62 87 76.84 156.34 164.95 156.34s160.34-69.35 165-156.34z" fill="#1afa29" p-id="7042"></path><path d="M851.94 704.45l-81.74-83.4a29.68 29.68 0 0 1-8.47-20.76V428.54c0-66.41-26-129-73.24-176.22a251.8 251.8 0 0 0-55.63-42.06 121.41 121.41 0 1 0-238-1.76 251.5 251.5 0 0 0-58.82 43.82c-47.23 47.23-73.24 109.81-73.24 176.22v171.55a29.68 29.68 0 0 1-8.46 20.75l-81.68 83.4-0.2 0.21a71.76 71.76 0 0 0 51.6 121.65h576.31a71.76 71.76 0 0 0 51.57-121.65zM514.05 159.83a25.44 25.44 0 0 1 25 20.7 249.56 249.56 0 0 0-26.73-1.44q-11.65 0-23.13 1.08a25.45 25.45 0 0 1 24.86-20.34zM281.73 730.1l52.64-51.75c13.08-12.42 24.46-25.88 24.46-43.83v-206a153.45 153.45 0 0 1 306.9 0v206c0 17.76 12.23 33.1 24 44.56l52.94 51z" fill="#1afa29" p-id="7043"></path></svg>
                          <helpIcon v-else style="color:#808080" class="typeIcon" title="" />
                          <span style="margin-left:10px;vertical-align:middle;">{{scope.row.startTime | formatDate}}{{'.'+scope.row.Millisecond}}</span>
                        </template>
                      </el-table-column>
                    <!-- Machine -->
                      <el-table-column
                          fixed   
                          prop="machineEn"
                          :label="$t('PartsFaultAlarm.tableTitle4')"
                          width="160">
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.equipmentName}}{{"(" + scope.row.machineZh + ")"}}</span>
                            <span v-else>{{scope.row.equipmentName}}{{"(" + scope.row.machineEn + ")"}}</span>
                          </template>
                      </el-table-column>
                    <!-- Code -->
                      <el-table-column
                          fixed
                          prop="msgEn"
                          :label="$t('PartsFaultAlarm.tableTitle5')"
                          width="260">
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.msgZh}}</span>
                            <span v-else>{{scope.row.msgEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- type -->
                      <el-table-column
                          fixed
                          prop="typeEn"
                          :label="$t('PartsFaultAlarm.tableTitle2')"
                          width="260">
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.typeZh}}</span>
                            <span v-else>{{scope.row.typeEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- Code/Description -->
                      <el-table-column
                          prop="descriptionEn"
                          :label="$t('PartsFaultAlarm.tableTitle3')"
                          min-width="254">
                           <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.descriptionZh}}</span>
                            <span v-else>{{scope.row.descriptionEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- Action -->
                      <el-table-column
                          prop="actionDesEn"
                          :label="$t('PartsFaultAlarm.Action')"
                          width="200">
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.actionDesZh}}</span>
                            <span v-else>{{scope.row.actionDesEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- End State -->
                      <el-table-column
                          prop="endStateDesEn"
                          :label="$t('PartsFaultAlarm.EndState')"
                          width="150">
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.endStateDesZh}}</span>
                            <span v-else>{{scope.row.endStateDesEn}}</span>
                          </template>
                      </el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page.sync="nowPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleCurrentSizeChange">
                </el-pagination>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import downloadIcon from "vue-material-design-icons/Download.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import replyIcon from "vue-material-design-icons/Reply.vue"
import helpIcon from "vue-material-design-icons/HelpCircle.vue"
import FilterVariant from "vue-material-design-icons/FilterVariant.vue"
//引入转换时间文件
import { formatDate } from '../assets/js/date.js'
import equipment from "@/components/Equipment.vue"

export default {
  name: 'PFA001',
  components: {
    leftNav,
    downloadIcon,
    alertIcon,
    replyIcon,
    helpIcon,
    FilterVariant,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      condition1: [],
      fullscreenLoading: false,
      loading: true,
      //我的代码
      partName:'Kinetix 5700',//设备
      partNameArr:[{//设备下拉框
          value: '选项1',
          label: 'Kinetix 5700'
        }],
      // **************搜索参数
      selectTime: [],// 筛选时间
      startTime: '',
      endTime: '',
      // 选中的机械id
      machineId:0,
      sort: '',
      // 当前页数
      nowPage: 1,
      nowPageSize: 10,
      // Action 筛选条件
      action:'',
      baseDataAllAction:[],
      // EndState 筛选条件
      endState:'',
      baseDataAllEndState:[],
      // Type 筛选条件
      TypeName:'',
      baseDataAllAllTypeName:[],
      // 输入查询的内容
      input:'',
      //查询伺服轴
      servoAxis:'',
      // **************搜索参数
      //日期限制条件 
      pickerOptions: {
        shortcuts: [ {
            text: this.$t('PartsFaultAlarm.radio1'),
            onClick(picker) {
              let initializeDateTime = new Date()
              let tYear = initializeDateTime.getFullYear();
              let tMonth = initializeDateTime.getMonth()+1;
              let tDate = initializeDateTime.getDate();
              let startDate = new Date(`${tYear}/${tMonth}/${tDate} 00:00:00`)
              let endDate = new Date(`${tYear}/${tMonth}/${tDate} 23:59:59`)
              startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 1);
              endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [startDate, endDate]);
            }
          },{
            text: this.$t('PartsFaultAlarm.radio2'),
            onClick(picker) {
              let initializeDateTime = new Date()
              let tYear = initializeDateTime.getFullYear();
              let tMonth = initializeDateTime.getMonth()+1;
              let tDate = initializeDateTime.getDate();
              let startDate = new Date(`${tYear}/${tMonth}/${tDate} 00:00:00`)
              let endDate = new Date(`${tYear}/${tMonth}/${tDate} 23:59:59`)
              startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [startDate, endDate]);
            }
          }],
        onPick: ({minDate}) => {
            this.pickerMinDate = minDate.getTime()
          },
          disabledDate: (time) =>{
            if (this.pickerMinDate !== '') {
              const day7 = 7 * 24 * 3600 * 1000
              let maxTime = this.pickerMinDate + day7
              let minTime = this.pickerMinDate - day7
              return (time.getTime() > maxTime ||
                        time.getTime() < minTime)
            } else {
              return ''
            }
          }
        //日期选择器左侧条件
        // shortcuts: [{
        //   text: this.$t('EventRecord.pickTime1'),
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 4);
        //     picker.$emit('pick', [start, end]);
        //   }
        // }, {
        //   text: this.$t('EventRecord.pickTime2'),
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 8);
        //     picker.$emit('pick', [start, end]);
        //   }
        // }]
      },
      //图标复选框选中状态
      checkList:[this.$t('PartsFaultAlarm.Faults'),this.$t('PartsFaultAlarm.Alarms')],
      // 表格数据
      tableData: [],
      // 总页数
      total:null,
      // 图表
      barChart: null,
      barChart2: null,
      // fal数据
      // faultData: [],
      seachLoading: false,
      // 图表
      myChart:null,
      myChart2:null,
      // fault(错误)数据
      faultData: [],
      // alarms(警告)数据
      alarmData: [],
      //选中的图标颜色
      faultsicon:false,
      alarmsicon:false,
      resetsicon:false,
      faultColor:'',
      alarmsColor:'',
      //点了查询之后才会改变的值，用在导出的赋值上
      dlmachineId:'',
      dlTypeName:'',
      dlservoAxis:'',
      dlinput:'',
      dlaction:'',
      dlstartTime:'',
      dlendTime:'',
      dlcheckList:[],
      //过滤代码/描述项的内容
      exceptinput:''
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    datevalue(){
      this.datevaluechange()
      this.correctionTime()
    }
  },
  created(){
    // 获取初始时间（一周的数据）
    this.getWeeksData()
    
  },
  mounted() {
    
    if(localStorage.getItem('isMarketAccount') === '1') {
      this.condition1 = [Number(this.$store.state.defaultShopId), Number(this.$store.state.defaultId)]
      this.machineId = Number(this.$store.state.defaultId)
    }
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }else{
      this.$store.commit('authority' , this.$route.path)
      this.condition1 = [Number(this.$store.state.defaultFactoryId), Number(this.$store.state.defaultId)]
      this.factoryId = Number(this.$store.state.defaultFactoryId)
      this.machineId =  Number(this.$store.state.defaultId)
      this.getManiceList()// 获取车间列表
      this.getselectDictInfo()//获取Action、End-State、Type的下拉数据
      this.getEventRecordList()//搜索
      this.selectIcons()
      // this.initChart()
      // this.initChart2()
      if(this.$store.state.lang === 1){
        this.checkList = ['错误','警告']
      }else{
        this.checkList = ['Faults','Alarms']
      }
    }
    
  },
  destroyed() {
  },
  methods: {
    // 切换设备
    getchange(value){
      this.condition1[1] = value
      this.machineId=value
      this.changeMachines()
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    changeTimes () {
      if (this.selectTime != '' && this.selectTime != null) {
        this.startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        this.endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
      } else {
        this.startTime = ''
        this.endTime = ''
        this.pickerMinDate = ''
      }
      // this.getEventData()
    },

    // 获取初始化时间（一周的数据）
    getWeeksData(){
      let initializeDateTime = new Date()
      let tYear = initializeDateTime.getFullYear();
      let tMonth = initializeDateTime.getMonth()+1;
      let tDate = initializeDateTime.getDate();

      let startDate1 = new Date(`${tYear}/${tMonth}/${tDate} 00:00:00`)
      let endDate = new Date(`${tYear}/${tMonth}/${tDate} 23:59:59`)
      let startChuo = startDate1.getTime()-86400000*6
      let startDate = new Date(startChuo)
      let startYear = startDate.getFullYear();
      let startMonth = startDate.getMonth()+1;
      let startD = startDate.getDate();

      this.selectTime = [startDate,endDate]
      this.startTime =`${startYear}-${startMonth}-${startD} 00:00:00`
      this.endTime = `${tYear}-${tMonth}-${tDate} 23:59:59`
      this.getEventRecord()
    },
    //我的代码
    changeLine () {
      // this.getEventData()
    },
    highSeaOrder (column) {
      if (column.prop) {
        if (column.order === 'ascending') {
          this.sort = ''
        } else {
          this.sort = 'asc'
        }
      } else {
        this.sort = ''
      }
      this.getEventRecordList()
    },
    changeMachines () {
      // this.machineId = Number(value[1])
      // this.condition1 // 选中的工场和机械的id数组
      if (this.condition1 != '' && this.condition1 != null) {
        if (this.condition1.length === 2) {
          this.lineId = ''
          this.machineId = this.condition1[1]
          this.shopId = ''
          this.factoryId = ''
        }
        if (this.condition1.length === 1) {
          this.lineId = ''
          this.machineId = ''
          this.shopId = ''
          this.factoryId = this.condition1[0]
        }
      }
      // this.getEventData()
    },
    //将复选框状态改成传参需要的数字1、2、3
    becomeNum(){
      let checkListor = this.checkList.map((item) => {
        if(item === this.$t('PartsFaultAlarm.Faults')){
          item = 1
        }else if(item === this.$t('PartsFaultAlarm.Alarms')){
          item = 2
        }
        return item
      });
      return checkListor
    },
    //导出时将复选框状态改成传参需要的数字1、2、3
    exportbecomeNum(){
      let checkListor = this.dlcheckList.map((item) => {
        if(item === this.$t('PartsFaultAlarm.Faults')){
          item = 1
        }else if(item === this.$t('PartsFaultAlarm.Alarms')){
          item = 2
        }
        return item
      });
      return checkListor
    },
    //获取Action、End-State、Type的下拉数据
    getselectDictInfo() {
      let _this = this
      let dataType = this.becomeNum()+''
      this.axios({
        method: 'get',
        url: '/url/selectChooseDict',
        params:{
          language: _this.$store.state.lang,
          dataTypes: dataType
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.baseDataAllAction = res.data.baseDataAllAction
          _this.baseDataAllEndState = res.data.baseDataAllEndState
          _this.baseDataAllAllTypeName = res.data.baseDataAllAllTypeName
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 过滤条件清空时请求数据
    clearexcept(){
      this.getEventRecordList()
    },
    // 过滤条件失去焦点时请求数据
    blurexcept(){
      this.getEventRecordList()
    },
    //搜索按钮请求数据
    getEventRecord(){
      let _this = this
      let dataType = this.becomeNum()+''
      this.axios({
        method: 'post',
        url: '/url/selectPartsWarnLog',
        params:{
          language: _this.$store.state.lang,
          machineId: _this.machineId, // 机器的id,
          typeValue:_this.TypeName, 
          descriptionValue:encodeURIComponent(_this.input),  
          actionValue:_this.action,  
          endStateValue:_this.endState, 
          startTime: _this.startTime, // 开始时间
          endTime: _this.endTime, // 结束时间
          sort: _this.sort,//排序
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          dataTypes: dataType,//状态：故障、警报
          servoAxis:_this.servoAxis,
          notDescriptionValue:encodeURIComponent(_this.exceptinput)
        }
      }).then(function(res){
          _this.total = res.data.total//页码数
          //获取图标状态
          if(JSON.stringify(res.data) !== "{}" && res.data.total!==0){
            res.data.rows.map(item =>{
              if(item.dataType === 1){

                if(item.typeEn !== null){
                  if(item.typeEn.indexOf('Faults Cleared') !== -1 ){
                    //出现过该字符串 绿
                    item.iconColor = '1绿'
                  }else{
                    //没有出现过 该字符串 红
                    item.iconColor = '1红'
                  }
                }

              }else if(item.dataType === 2){

                if(item.actionDesEn !== null){
                  if(item.actionDesEn.indexOf('Alarm off') !== -1 ){
                    //出现过该字符串 绿
                    item.iconColor = '2绿'
                  }else{
                    //没有出现过 该字符串 红
                    item.iconColor = '2红'
                  }
                }
              }
            })
          }
          _this.tableData = res.data.rows
          
          //获取毫秒
          _this.tableData.forEach(item=>{
            let getMillisecond = new Date(item.startTime).getMilliseconds()
            if(getMillisecond < 10){
              getMillisecond = '00'+ getMillisecond
            }else if(getMillisecond<100){
              getMillisecond = '0'+ getMillisecond
            }
            item.Millisecond = getMillisecond
          })
          // 获取echarts数据
            // if (res.data.faultData != null) {
              // document.getElementById("myChart").style.display="inline"
              // _this.faultData = res.data.faultData
            // }else {
            //   _this.faultData = null
              // document.getElementById("myChart").style.display = "none"
            // }
            // if (res.data.alarmData != null) {
            //   document.getElementById("myChart2").style.display="inline"
            //   _this.alarmData = res.data.alarmData
            // }else {
            //   _this.alarmData = null
            //   document.getElementById("myChart2").style.display = "none"
            // }
            // _this.initChart()
            // _this.initChart2()
          _this.loading = false
          
      }).catch(function () {
          _this.loading = false
      })
    },
    //搜索请求
    getEventRecordList() {
      if (this.startTime == '' && this.endTime == '') {
        this.$message.error(this.$t('EventRecord.selectTimeError'))
        return
      }
      this.nowPage = 1
      this.loading = true
      let checkarr =[]
      this.checkList.forEach(item=>{
        checkarr.push(item)
      })
      localStorage.setItem("partName", this.partName)
      localStorage.setItem("startTime", this.startTime)
      localStorage.setItem("endTime", this.endTime)
      localStorage.setItem("checkList",checkarr)
      localStorage.setItem("TypeName", this.TypeName)
      localStorage.setItem("input", this.input)
      localStorage.setItem("servoAxis", this.servoAxis)
      localStorage.setItem("machineId", this.machineId)
      localStorage.setItem("exceptinput", this.exceptinput)
      this.dlmachineId=this.machineId
      this.dlTypeName=this.TypeName
      this.dlservoAxis=this.servoAxis
      this.dlinput=this.input
      this.dlaction=this.action
      this.dlstartTime=this.startTime
      this.dlendTime=this.endTime
      this.dlcheckList=this.checkList
      this.getEventRecord()
    },
    // 分页
    handleCurrentChange (val) {
      this.nowPage = val
      this.getEventRecordListPage()
    },
    getEventRecordListPage () { 
      this.loading = true
      this.partName = localStorage.getItem("partName")
      this.startTime = localStorage.getItem("startTime")
      this.endTime = localStorage.getItem("endTime")
      this.checkList = localStorage.getItem("checkList").split(",")
      this.TypeName = Number(localStorage.getItem("TypeName"))?Number(localStorage.getItem("TypeName")):''
      this.servoAxis = localStorage.getItem("servoAxis")
      this.input = localStorage.getItem("input")
      this.exceptinput = localStorage.getItem("exceptinput")
      this.machineId=localStorage.getItem("machineId")
      this.startDate =  formatDate(new Date(this.startTime), 'yyyy-MM-dd hh:mm:ss')
      this.endDate =  formatDate(new Date(this.endTime), 'yyyy-MM-dd hh:mm:ss')
      this.selectTime = [this.startDate,this.endDate]
      this.getEventRecord()
    },
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.getEventRecordList()
    },
    //选中的图标
    selectIcons(){
        if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Faults')) === -1){
          this.faultsicon = false
        }else{
          this.faultsicon = true
        }
         if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Alarms')) === -1){
          this.alarmsicon = false
        }else{
          this.alarmsicon = true
        }
        if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Resets')) === -1){
          this.resetsicon = false
        }else{
          this.resetsicon = true
        }
        this.action = ''
        this.endState = ''
        this.TypeName = ''
        this.getselectDictInfo()
    },
    // 导出功能
    btn_export () {
       if(this.tableData== undefined || this.tableData.length <= 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        let dataType = this.exportbecomeNum()+''
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        if(this.$store.state.lang===1){
          this.urlData = '?language=' + this.$store.state.lang +'&notDescriptionValue='+encodeURIComponent(this.exceptinput)+ '&machineId=' + this.dlmachineId + '&typeValue=' + this.dlTypeName + '&MsgZh=' + this.dlservoAxis + '&descriptionValue=' + this.dlinput + '&actionValue=' + this.dlaction + '&endStateValue=' + this.endState + '&startTime=' + this.dlstartTime  + '&endTime=' + this.dlendTime + '&sort=' + this.sort + '&pageNum=' + this.nowPage + '&pageSize=' + this.nowPageSize + '&dataTypes=' + dataType +'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        }else{
          this.urlData = '?language=' + this.$store.state.lang +'&notDescriptionValue='+encodeURIComponent(this.exceptinput)+ '&machineId=' + this.dlmachineId + '&typeValue=' + this.dlTypeName + '&MsgEn=' + this.dlservoAxis + '&descriptionValue=' + this.dlinput + '&actionValue=' + this.dlaction + '&endStateValue=' + this.endState + '&startTime=' + this.dlstartTime  + '&endTime=' + this.dlendTime + '&sort=' + this.sort + '&pageNum=' + this.nowPage + '&pageSize=' + this.nowPageSize + '&dataTypes=' + dataType +'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        }
        
        window.open('/download/partsWarnExportLog' + this.urlData, '_blank')
      }
    },
    // 清除功能
    btn_clean () {
      // this.condition1 = [Number(this.$store.state.defaultFactoryId), Number(this.$store.state.defaultId)]
      // this.factoryId = Number(this.$store.state.defaultFactoryId)
      // this.machineId =  Number(this.$store.state.defaultId)
      // 部件
      this.partName=''
      this.selectTime = [],// 筛选时间
      this.startTime = ''
      this.endTime = ''
      // 选中的机械id
      // this.machineId = ''
      // this.sort =  ''
      // 当前页数
      this.nowPage =  1
      this.nowPageSize =  10
      // Action 筛选条件
      this.action = ''
      // this.baseDataAllAction = []
      // EndState 筛选条件
      this.endState = ''
      // this.baseDataAllEndState = []
      // Type 筛选条件
      this.TypeName = ''
      // this.baseDataAllAllTypeName = []
      // 输入查询的内容
      this.input = ''
      this.servoAxis=''
      //图标复选框状态
      this.checkList = []
      this.exceptinput=''
      // this.getManiceList ()
      // this.getEventRecordList()//调用搜索
    },
    // 图表初始化
    initChart(){
      let _this = this
      _this.codeArr = []
      _this.desArr = []
      _this.numArr = []
      // for (const item of _this.faultData) {
      //   _this.codeArr.push(item.msgCode)
      //   _this.numArr.push(item.codeNum)
      //   if (this.$store.state.lang === 1) {
      //     _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
      //   }else {
      //    if (item.msgEn !=null ){
      //       _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
      //     }else{
      //       _this.desArr.push(item.group + '-' + item.em )
      //     }  
      //   }
      // }
      let timeTitle = ''
      if (this.selectTime != '' && this.selectTime != null) {
        let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
        timeTitle = `${startTime} ~ ${endTime}`
      }
      this.barChart = this.$echarts.init(document.getElementById('myChart'))
      this.barChart.setOption({
        title: {
          text: _this.$t('EventRecord.chartTitle'),
          subtext: timeTitle
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter:function(params){
            let titleIndex = params[0].dataIndex
            let titleArr =  params[0].seriesName.split(',')
            
            return params[0].axisValue + '<br/>' +
                        titleArr[titleIndex] + ' : ' +
                        params[0].data
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          // data: _this.codeArr
          data: ['巴西','印尼','美国']
        },
        series: [
          {
              name: _this.desArr,
              type: 'bar',
              itemStyle: {
                    normal: {color: '#085ba6'}
              },
              // data: _this.numArr
              data: [18203, 23489, 29034]
          }
        ]
      })
    },
    initChart2(){
      // let _this = this
      // _this.codeArr = []
      // _this.desArr = []
      // _this.numArr = []
      // for (const item of _this.alarmData) {
      //   _this.codeArr.push(item.msgCode)
      //   _this.numArr.push(item.codeNum)
      //    if (this.$store.state.lang === 1) {
      //     _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
      //   }else {
      //     if (item.msgEn !== null ){
      //       _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
      //     }else{
      //       _this.desArr.push(item.group + '-' + item.em)
      //     }  
      //   }
      // }
      // let timeTitle = ''
      // if (this.selectTime != '' && this.selectTime != null) {
      //   let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
      //   let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
      //   timeTitle = `${startTime} ~ ${endTime}`
      //   }
      // this.barChart2 = this.$echarts.init(document.getElementById('myChart2'))
      // this.barChart2.setOption({
      //     title: {
      //     text: _this.$t('EventRecord.chartTitle2'),
      //     subtext: timeTitle
      // },
      // tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //         type: 'shadow'
      //     },
      //     formatter:function(params){
      //       let titleIndex = params[0].dataIndex
      //       let titleArr =  params[0].seriesName.split(',')
            
      //       return params[0].axisValue + '<br/>' +
      //                   titleArr[titleIndex] + ' : ' +
      //                   params[0].data
      //     }
      // },
      // grid: {
      //     left: '3%',
      //     right: '4%',
      //     bottom: '3%',
      //     containLabel: true
      // },
      // xAxis: {
      //     type: 'value',
      //     boundaryGap: [0, 0.01]
      // },
      // yAxis: {
      //     type: 'category',
      //     data: _this.codeArr
      // },
      // series: [
      //     {
      //         name: _this.desArr,
      //         type: 'bar',
      //         itemStyle: {
      //               normal: {color: '#085ba6'}
      //         },
      //         data: _this.numArr
      //     }
      //   ]
      // })
    },
  },
  filters: {//转换时间发方法
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy/MM/dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
.PartsFaultAlarm{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 35px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
  display: flex;
  align-items: center;
}
/* 我的样式 */
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}
.selectGroup{
  width: 190px;
}
.selectGroup2{
  width: 120px;
}
.tableWrap{
  padding: 25px 30px;
}
.titleRow{
   display: flex;
    line-height: 40px;
}
.titleRow label{
  font-size: 12px;
  margin-left: 9.5px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  color: #6772e5;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.chartWrap{
  width: 100%;
  display: flex;
  margin: 15px 0;
}
.chartWrap div{
  width: 50%;
  height: 200px;
  margin: 0 5%;
}

.type-select-width{
    width: 170px;
}
.code-select-width{
    width: 144px;
}
.code-margin{
    margin-left: 10px;
}
.showself{
  display: flex;
  margin-left: 10px;
  height: 40px;
}
.ShowWord{
  line-height: 40px;
  margin-right: 10px;
}
.iconse{
  margin-left: 2px;
  font-size: 14px;
}
.faultsRed{
  color: #ff0000;
}
.faultsGreen{
  color: #6ff063;
}
.alarmsRed{
  font-weight: 800;
  color: #ff0000;
}
.alarmsGreen{
  font-weight: 800;
  color: #64f557;
  /* font-size: 16px; */
  /* color: #e6a23c; */
}
.iconcolor{
  color: #409EFF;
}
/* element-ui样式 */
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
    width: 400px;
}
.el-checkbox{
    margin: 0 0 0 5px;
}
.el-checkbox:nth-child(1){
    margin: 0;
}
.el-button--text{
    color: #808080;
    
}
/* .el-checkbox .el-checkbox__label{
  padding-left: 2px;
} */
/* 过滤代码/描述的样式 */
.except{
    color: red;
}
</style>

